import { Stack, Tooltip, useTheme, StackProps } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import React, { ReactNode } from "react";

interface TextInfoProps extends StackProps {
  children: ReactNode;
  tooltipMsg: string;
}

const NewTextInfo: React.FC<TextInfoProps> = ({
  children,
  tooltipMsg,
  ...rest
}) => {
  const theme = useTheme();
  return (
    <Stack direction="row" alignItems="center" gap={1} {...rest}>
      {children}
      <Tooltip title={tooltipMsg}>
        <InfoOutlinedIcon
          sx={{ fontSize: theme.spacing(2), cursor: "pointer" }}
        />
      </Tooltip>
    </Stack>
  );
};

export default NewTextInfo;
